import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ConsumerAddEditComponent } from '../add-edit/consumer-add-edit.component';
import { ConsumerModel } from '../../models/consumerModel';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import { ConsumerListModel } from '../../models/consumerListModel';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/components/confirmation/confirm-dialog.component';
import { ToastService } from 'src/app/services/toaster.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-consumer-list',
  templateUrl: './consumer-list.component.html',
  styleUrl: './consumer-list.component.css'
})
export class ConsumerListComponent {
  public pageSize = 10;
  public currentPage = 0;
  public totalSize = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  consumerList: ConsumerListModel[] = [];
  sortedConsumerList: ConsumerListModel[] = [];
  consumerModel: ConsumerModel = new ConsumerModel();
  dataSource = new MatTableDataSource<ConsumerListModel>();
  isAdvanceSearchFilter: boolean = false;
  filterKey: string = '';
  currentSort!: Sort;
  selectedOption: string = '';
  displayedColumns = ['name','email','description','status','updatedAt', 'action'];
  isWritePermission: boolean = true;
  constructor(public _restAPI: RestAPIService, public dialog: MatDialog, private toast: ToastService, private permissionService: PermissionService){
    this._restAPI.loading  = false;
    if(!this.permissionService.has('consumer.write')){
      this.isWritePermission = false;
      this.displayedColumns = this.displayedColumns.filter(col => col !== 'action');
    }
  }

  ngOnInit() {
    if (localStorage["applyConsumerFilterValue"] === 'true') {
        this.getConsumerList(localStorage["consumerFilterValue"]);
    }
    else {
        this.getConsumerList('');
    }
    localStorage["applyConsumerFilterValue"] = '';
  }

  onDisplayFilter(e : any) {
    this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
    if(e) {
        e.stopPropagation();
    }
  }

  applyFilter(filterValue: string) {
    if (this.dataSource?.paginator) {
        this.dataSource.paginator.pageIndex = 0;
    }
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    localStorage["consumerFilterValue"] = filterValue;
    this.dataSource.filter = filterValue;
  }

  applyActiveFilter(){
    this.dataSource.data = this.consumerList;
    if(this.selectedOption === '1'){
        this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === true);
    }
    else if(this.selectedOption === '2'){
        this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === false);
    }
  }

  clearFilter(){
    this.selectedOption = '';
    this.filterKey='';
    this.applyActiveFilter();
    this.applyFilter('');
  }

  openConsumerDialog(consumerModel: ConsumerModel): void {
    const dialogRef = this.dialog.open(ConsumerAddEditComponent, {
        width:"1024px",
        data:{
            consumerModel: consumerModel
        } 
    });

    dialogRef.afterClosed().subscribe(result => {
        this.consumerModel = new ConsumerModel();
        if (result) {
            this.getConsumerList(localStorage["consumerFilterValue"]);
        }
        localStorage["applyConsumerFilterValue"] = '';
    });
  }

  async getConsumerList(filterValue : any) {
    this._restAPI.loading  = true;
    this._restAPI.get<ConsumerListModel[]>(environment.apiURL + 'api/consumer/list').subscribe({
        next: (data) => {
            this._restAPI.loading  = false;
            for(let consumerObj of data){
                if(!consumerObj.updatedOn){
                    consumerObj.updatedOn = consumerObj.createdOn;
                }
            }
            this.consumerList = data;
            this.sortedConsumerList = this.consumerList.slice();
            this.totalSize = this.sortedConsumerList.length;
            this.dataSource.data = data;
            this.dataSource.filter = filterValue;
            this.filterKey = filterValue;
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        },
        error: (error) =>{console.error(error); this._restAPI.loading  = false;}
    });
  }

  sortConsumers(sort: Sort) {
      if (this.dataSource?.paginator) {
          this.dataSource.paginator.pageIndex = 0;
      }
      // this.dataSource.filter = "";
      this.filterKey = "";
      this.currentSort = sort;
      this.pageSize = 10;
      this.currentPage = 0;
      // this.sortConsumerArray(this.consumerList.slice(), this.currentSort);
      this.sortConsumerArray(this.dataSource.data.slice(), this.currentSort);
      this.dataSource.data = this.sortedConsumerList;
  }

  onToggleChange(event: MatSlideToggleChange, id: string){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '500px',
        data: {
          message: `Are you sure you want to ${event.checked ? 'active' : 'inactive'} this consumer?`
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
            console.log('Toggle changed:', event.checked); // true or false

            let postData = {
                consumerId: id,
                isActive: event.checked
              };

            this._restAPI.loading  = true;  
            this._restAPI.put<string>(environment.apiURL + 'api/consumer/activeinactive', postData).subscribe({
                next: (results) => {
                    this._restAPI.loading  = false;
                    dialogRef.close(true);
                    this.toast.show("Consumer has been updated succussfully");
                },
                error: (error) => {console.error(error);this._restAPI.loading  = false;}
            });

          //this.isToggled = event.checked;
          //event.source.checked = this.isToggled;
        }
        else{
            event.source.checked = !event.checked;
        }
      });
  }

  private sortConsumerArray(consumers: ConsumerListModel[], sort: Sort): void {
      if (sort === undefined || !sort.active || sort.direction === '') {
          this.sortedConsumerList = consumers.slice();
          return;
      }
      this.sortedConsumerList = consumers.sort((a, b) => {
          const isAsc = sort.direction === 'asc';
          switch (sort.active) {
              case 'name': return compare(a.name ?? '', b.name ?? '', isAsc);
              case 'email': return compare(a.email ?? '', b.email ?? '', isAsc);
              case 'description': return compare(a.description ?? '', b.description ?? '', isAsc);
              case 'status': return compare(a.isActive ?? false, b.isActive ?? false, isAsc);
              case 'updatedAt': return compare(a.updatedOn ?? new Date(-8640000000000000), b.updatedOn ?? new Date(-8640000000000000), isAsc);
              default: return 0;
          }
      });

      const part = this.sortedConsumerList.slice();
      this.sortedConsumerList = [];
      for (const user of part) {
          this.sortedConsumerList.push(user);
      }
  }

  private getDate(date : Date | null){
      if(date){
          return moment.utc(date).local().format('YYYY-MM-DD hh:mm A');
      }
      else{
          return null;
      }
  }

  private copyText(text: string, messageHeader: string){
    // navigator.clipboard.writeText(text);
    // this.toast.show(messageHeader +" copied to clipboard.")
    try{
      navigator.clipboard.writeText(text);
      this.toast.show(messageHeader +" copied to clipboard.")
    }catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.toast.show(messageHeader +" copied to clipboard.")
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      document.body.removeChild(textArea);
    }
  }
}

function compare(a: number | string | boolean | Date, b: number | string | boolean | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}